import { memo } from "react";

import { Button, type Size as ButtonSize } from "@components/Button";
import { ThemeMode } from "@root/tablescape/state";
import { tw } from "classnames";

type Props = {
  handleModalButtonClick: () => void;
  playVideo: string;
  size: ButtonSize;
  theme: ThemeMode;
};

const styles = {
  base: tw("flex"),
  buttonIcon: tw("h-3", "w-3"),
};

const ProductVideoModalButtonViewBase = ({
  handleModalButtonClick,
  playVideo,
  size,
  theme = ThemeMode.LIGHT,
}: Props) => {
  return (
    <Button
      className={styles.base}
      iconClassName={styles.buttonIcon}
      iconName="play"
      iconPosition="start"
      onClick={handleModalButtonClick}
      size={size}
      type={theme === ThemeMode.DARK ? "secondary-alt" : "secondary"}
    >
      {playVideo}
    </Button>
  );
};

export const ProductVideoModalButtonView = memo(
  ProductVideoModalButtonViewBase
);
